const CreateStory_mutate = `
    mutation createStory(
      $userUuid: String!,
      $title: String!,
      $content: String!,
      $isPublished: Boolean!,
      $file: Upload,
      $s3FileName: String
      ) {
      createStory(
        userUuid: $userUuid,
        title: $title,
        content: $content,
        isPublished: $isPublished,
        file: $file,
        s3FileName: $s3FileName) {
        
        story
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          storyId
          userId
          {
            username
          }
          title
          content
          isPublished
          fileName
          commentNo
          likeNo
          shareNo
        }
      }
    }
`;

const EditStory_mutate = `
    mutation editStory(
      $storyUuid: String!,
      $title: String!,
      $content: String!,
      $isPublished: Boolean!,
      $file: Upload,
      $s3FileName: String,
      $removeFile: Boolean,
      ) {
      editStory(
        storyUuid: $storyUuid,
        title: $title,
        content: $content,
        isPublished: $isPublished,
        file: $file,
        s3FileName: $s3FileName,
        removeFile: $removeFile) {
        
        story
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          storyId
          userId
          {
            username
          }
          title
          content
          isPublished
          fileName
          commentNo
          likeNo
          shareNo
        }
      }
    }
`;

const UpdateStoryStatus_mutate = `
    mutation updateStoryStatus(
      $storyUuid: String!,
      $isPublished: Boolean!,
      ) {
      updateStoryStatus(
        storyUuid: $storyUuid,        
        isPublished: $isPublished) {
        
        story
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          storyId
          userId
          {
            username
          }
          title
          content
          isPublished
          fileName
          commentNo
          likeNo
          shareNo
        }
      }
    }
`;

const UpdateStoryShareNo_mutate = 
`mutation UpdateStoryShareNo(
  $storyUuid: String!) {
    updateStoryShareNo(storyUuid: $storyUuid) 
    {
      story
      {
        createBy
        createDate
        updateDate
        updateBy
        uuid
        storyId
        userId
        {
          username
        }
        title
        content
        isPublished
        fileName
        commentNo
        likeNo
        shareNo
      }
    }
  }
`;

const DeleteStory_mutate = `
    mutation deleteStory(
      $storyUuid: String!,      
      ) {
      deleteStory(
        storyUuid: $storyUuid) {
        
         response
      }
    }
`;


const StoriesByUserUuid_query = `query($userUuid: String!,$status: String){
  storiesByUseruuid(userUuid: $userUuid,status: $status){
    storyId
    uuid    
    title
    content
    isPublished
    publishedDate
    commentNo
    shareNo
    likeNo
    fileName
    isLiked
    isInCollection    
    createBy
    createDate
    updateBy
    updateDate
    userId{
      id
      userUuid
      firstName
      lastName
      username
      avatarFileName
      listings
      soldToys
      ratingNo
      ratingCount
      dateJoined
      isLoggedInUserFollowing
    }
    storyLikes{
      storyLikeId
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
    }
    storyComments{
      uuid
      storyCommentId
      content
      likeNo
      isLiked
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
      replies{
        uuid
        userId
        {
          username
          avatarFileName
          isLoggedInUserFollowing
        }
        content
        storyCommentId{
          storyCommentId
        }
        likeNo
        isLiked
        createBy
        createDate
        updateDate
        updateBy
      }
      createBy
      createDate
      updateBy
      updateDate
    }
  }  
}`;

const StoryByUuid_query = `query($uuid: String!){
  storyByUuid(uuid: $uuid){
    storyId
    uuid
    userId
    {
      id
      userUuid
      firstName
      lastName
      username
      avatarFileName
      listings
      soldToys
      ratingNo
      ratingCount
      dateJoined
      isLoggedInUserFollowing        
    }
    
    title
    content
    isPublished
    publishedDate
    commentNo
    shareNo
    likeNo
    fileName
    fileSize
    isLiked
    isInCollection
    storyComments{
      uuid
      storyCommentId      
      content
      likeNo
      isLiked
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
      isLiked
      createBy
      createDate
      updateBy
      updateDate
      replies{
        uuid
        userId
        {
          username
          avatarFileName
          isLoggedInUserFollowing
        }
        content
        storyCommentId{
          storyCommentId
        }
        likeNo
        isLiked
        createBy
        createDate
        updateDate
        updateBy
      }
    }
    createBy
    createDate
    updateBy
    updateDate
  }  
}`;

const CreateStoryLike_mutate = `
  mutation createStoryLike(
    $storyUuid: String!,     
  ) {
    createStoryLike(
      storyUuid: $storyUuid,        
    ) {        
      storyLike
        {
          uuid
          userId
          {
            id
            username            
          }
          storyId
          {
            storyId
            title           
          }
        }
      }
    }
`;

const DeleteStoryLike_mutate = `
  mutation deleteStoryLike(
    $storyUuid: String!     
  ) {
    deleteStoryLike(
      storyUuid: $storyUuid        
      ) {        
      response
    }
  }
`;

const AllStories_query = `query{
  allStories{
    storyId
    uuid    
    title
    content
    isPublished
    publishedDate
    commentNo
    shareNo
    likeNo
    fileName
    isLiked
    isInCollection    
    createBy
    createDate
    updateBy
    updateDate
    userId{
      id
      userUuid
      firstName
      lastName
      username
      avatarFileName
      listings
      soldToys
      ratingNo
      ratingCount
      dateJoined
      isLoggedInUserFollowing
    }
    storyLikes{
      storyLikeId
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
    }
    storyComments{
      uuid
      storyCommentId
      content
      likeNo
      isLiked
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
      createBy
      createDate
      updateBy
      updateDate
    }
  }  
}`;

const CreateStoryComment_mutate = `
  mutation createStoryComment(
    $storyUuid: String!,
    $content: String!,     
  ) {
    createStoryComment(
      storyUuid: $storyUuid,
      content: $content,         
    ) {        
      storyComment
        {
          uuid
          userId
          {
            id
            username
            avatarFileName            
          }
          storyId
          {
            storyId
            title           
          }
          title
          content
          likeNo
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const DeleteStoryComment_mutate = `
  mutation deleteStoryComment(
    $storyCommentUuid: String!,      
  ) {
    deleteStoryComment(
      storyCommentUuid: $storyCommentUuid,       
      ) {        
      response
    }
  }
`;

const EditStoryComment_mutate = `
    mutation editStoryComment(
      $storyCommentUuid: String!,
      $content: String!,      
    ) {
      editStoryComment(
        storyCommentUuid: $storyCommentUuid,
        content: $content) {        
        storyComment
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          storyCommentId
          userId
          {
            username
          }
          storyId
          {
            uuid
          }
          title
          content          
          likeNo
        }
      }
    }
`;

const CreateStoryCommentLike_mutate = `
  mutation createStoryCommentLike(
    $storyCommentUuid: String!,     
  ) {
    createStoryCommentLike(
      storyCommentUuid: $storyCommentUuid,        
    ) {        
      storyCommentLike
        {
          uuid
          userId
          {
            id
            username            
          }
          storyCommentId
          {
            storyCommentId
            title           
          }
        }
      }
    }
`;

const DeleteStoryCommentLike_mutate = `
  mutation deleteStoryCommentLike(
    $storyCommentUuid: String!     
  ) {
    deleteStoryCommentLike(
      storyCommentUuid: $storyCommentUuid        
      ) {        
      response
    }
  }
`;

const CreateStoryCommentReply_mutate = `
  mutation createStoryCommentReply(
    $storyCommentUuid: String!,
    $content: String!,     
  ) {
    createStoryCommentReply(
      storyCommentUuid: $storyCommentUuid,
      content: $content,         
    ) {        
      storyCommentReply
        {
          uuid
          userId
          {
            id
            username
            avatarFileName            
          }
          storyCommentId
          {
            storyCommentId
            title
            content           
          }
          content
          likeNo
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const DeleteStoryCommentReply_mutate = `
  mutation deleteStoryCommentReply(
    $storyCommentReplyUuid: String!,      
  ) {
    deleteStoryCommentReply(
      storyCommentReplyUuid: $storyCommentReplyUuid,       
      ) {        
      response
    }
  }
`;

const EditStoryCommentReply_mutate = `
    mutation editStoryCommentReply(
      $storyCommentReplyUuid: String!,
      $content: String!,      
    ) {
      editStoryCommentReply(
        storyCommentReplyUuid: $storyCommentReplyUuid,
        content: $content) {        
        storyCommentReply
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          storyCommentReplyId
          userId
          {
            username
          }
          storyCommentId
          {
            uuid
            title
            content
          }
          content          
          likeNo
        }
      }
    }
`;

const CreateStoryCommentReplyLike_mutate = `
  mutation createStoryCommentReplyLike(
    $storyCommentReplyUuid: String!,     
  ) {
    createStoryCommentReplyLike(
      storyCommentReplyUuid: $storyCommentReplyUuid,        
    ) {        
      storyCommentReplyLike
        {
          uuid
          userId
          {
            id
            username            
          }
          storyCommentReplyId
          {
            storyCommentReplyId
            content           
          }
        }
      }
    }
`;

const DeleteStoryCommentReplyLike_mutate = `
  mutation deleteStoryCommentReplyLike(
    $storyCommentReplyUuid: String!     
  ) {
    deleteStoryCommentReplyLike(
      storyCommentReplyUuid: $storyCommentReplyUuid        
      ) {        
      response
    }
  }
`;

module.exports = {
  CREATE_STORY_MUTATION : CreateStory_mutate,
  EDIT_STORY_MUTATION : EditStory_mutate,
  UPDATE_STORY_STATUS: UpdateStoryStatus_mutate,
  UPDATE_STORY_SHARE_NO: UpdateStoryShareNo_mutate,
  DELETE_STORY: DeleteStory_mutate,
  STORY_BY_UUID: StoryByUuid_query,
  STORIES_BY_USER_UUID: StoriesByUserUuid_query,
  CREATE_STORY_LIKE_MUTATION: CreateStoryLike_mutate,
  DELETE_STORY_LIKE_MUTATION: DeleteStoryLike_mutate,
  ALL_STORIES_QUERY: AllStories_query,
  CREATE_STORY_COMMENT_MUTATION: CreateStoryComment_mutate,
  DELETE_STORY_COMMENT_MUTATION: DeleteStoryComment_mutate,
  EDIT_STORY_COMMENT_MUTATION : EditStoryComment_mutate,
  CREATE_STORY_COMMENT_LIKE_MUTATION: CreateStoryCommentLike_mutate,
  DELETE_STORY_COMMENT_LIKE_MUTATION: DeleteStoryCommentLike_mutate,
  CREATE_STORY_COMMENT_REPLY_MUTATION: CreateStoryCommentReply_mutate,
  DELETE_STORY_COMMENT_REPLY_MUTATION: DeleteStoryCommentReply_mutate,
  EDIT_STORY_COMMENT_REPLY_MUTATION: EditStoryCommentReply_mutate,
  CREATE_STORY_COMMENT_REPLY_LIKE_MUTATION: CreateStoryCommentReplyLike_mutate,
  DELETE_STORY_COMMENT_REPLY_LIKE_MUTATION: DeleteStoryCommentReplyLike_mutate,
}
